import React from 'react';

import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors, HStack, Text } from '@rtkwlf/fenrir-react';
import { faExclamationTriangle } from '@rtkwlf/pro-solid-svg-icons/faExclamationTriangle';
import { faTimes } from '@rtkwlf/pro-solid-svg-icons/faTimes';
import { useTranslation } from 'react-i18next';

import { useContactInfo } from '@apis/rendall/queries/use-contact-info';
import { getFormattedPhoneAndEmail } from '@packages/utils/phone';

const ErrorWrapper = styled(HStack)`
  display: flex;
  padding: var(--aw-size-space-8) var(--aw-size-space-16);
  border-radius: var(--aw-size-space-4);
  background: rgb(var(--aw-color-background-danger-ultra));
  border-left-color: rgb(var(--aw-color-background-danger-ultra));
  border: 1px solid rgb(var(--aw-color-background-danger-base));
`;

export const ContactErrorMessage: React.FC<{
  onClose: () => void;
  errorMessage?: string;
}> = ({ onClose, errorMessage }) => {
  const { t } = useTranslation();
  const { data } = useContactInfo();

  return (
    <ErrorWrapper xAlign="between" zIndex={2} title={t('contact:errorTitle')}>
      <HStack>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          color={`rgb(${colors.icon.danger.default})`}
        />
        <Text styledAs="body1">
          {errorMessage ?? getFormattedPhoneAndEmail(t('contact:error'), data)}
        </Text>
      </HStack>

      <FontAwesomeIcon
        icon={faTimes}
        data-testid={t('ui:footer.closeButtonText')}
        title={t('contact:closeMessage')}
        onClick={onClose}
      />
    </ErrorWrapper>
  );
};
